import * as yup from 'yup';

export const initialValues = {
  question: '',
  answer: '',
};

// Helper to detect empty rich text
const isRichTextEmpty = value => {
  const stripped = value
    .replace(/<(.|\n)*?>/g, '') // Remove HTML tags
    .replace(/&nbsp;/g, '') // Remove non-breaking spaces
    .trim();
  return stripped.length === 0;
};

export const validationSchema = yup.object().shape({
  question: yup.string().trim().required('Question is required'),
  answer: yup
    .string()
    .test(
      'rich-text-not-empty',
      'Answer is required',
      value => !isRichTextEmpty(value),
    ),
});
